<template>
  <v-row justify="center">
    <v-dialog v-model="internalDialogActive" persistent max-width="450">
      <v-card class="text-center pa-10 justify-center">
        <v-icon v-if="success" color="success" size="64" class="mt-3">
          check_circle
        </v-icon>
        <v-progress-circular
          v-else
          class="mt-3"
          :size="64"
          :width="5"
          color="primary"
          :indeterminate="!hasProgress"
          :value="progressPercent"
        >
          <span v-if="hasProgress" class="text-caption">{{ progressPercent }}%</span>
        </v-progress-circular>
        <v-card-title class="text-title justify-center mt-2">
          {{ message }}
        </v-card-title>
        <v-card-text v-if="!success">
          {{ hasProgress ? `Aguarde.. ${current} de ${total}` : "Aguarde.." }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "LoaderDialogView",
  props: {
    activeDialog: { type: Boolean, default: false },
    message: { type: String, default: "Carregando" },
    current: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    success: { type: Boolean, default: false },
  },
  data() {
    return {
      internalDialogActive: false,
    };
  },
  computed: {
    hasProgress() {
      return this.total > 0;
    },
    progressPercent() {
      if (!this.hasProgress) return 0;
      return Math.round((this.current / this.total) * 100);
    },
  },
  watch: {
    activeDialog(newValue) {
      this.internalDialogActive = newValue;
    },
  },
  mounted() {
    this.internalDialogActive = this.activeDialog;
  },
};
</script>
